<a class="ou-get-back" (click)="back()">
  <mat-icon class="material-icons-outlined">arrow_back_ios</mat-icon>
  <div class="ou-get-back-title">{{instance.name}} részletek</div>
</a>
<div class="edit-project-container" *ngIf="instance.id.length > 0">
  <mat-accordion *ngIf="projectPermission.update || user.isSuperAdminIn(instance.organizationUnit.name)" class="ticket-list" multi>
    <mat-expansion-panel class="edit-container">
      <mat-expansion-panel-header (click)="$event.stopPropagation()" [collapsedHeight]="'30px'"
        [expandedHeight]="'30px'">
        Projekt adatok
      </mat-expansion-panel-header>
      <div class="project-details">
        <div class="project-details-flex">
          <div>Projekt neve:</div>
          <div> {{instance.name}}</div>
          <app-button
            [icon]="'edit'"
            [customColor]="'yellow'"
            (click)="openEditModal()"
          ></app-button>
        </div>
        <div class="project-details-flex">
          <div>Projekt törlése:</div>
          <app-button
            [icon]="'delete'"
            [title]="'törlés'"
            [customColor]="'red'"
            [matMenuTriggerFor]="delProjectMenu"
          ></app-button>
        </div>
        <mat-menu class="menu-for-delete" #delProjectMenu="matMenu" xPosition="before">
          <div class="ticket-delete-title">Biztosan törli a projektet?</div>
          <div
            class="ticket-delete-option"
            (click)="deleteProject()"
          >Igen (visszavonhatatlan)</div>
          <div
            class="ticket-delete-option"
          >nem</div>
        </mat-menu>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="projectPermission.manageUsers || user.isSuperAdminIn(instance.organizationUnit.name)" class="edit-container">
      <mat-expansion-panel-header (click)="$event.stopPropagation()" [collapsedHeight]="'30px'"
        [expandedHeight]="'30px'">
        Felhasználók
      </mat-expansion-panel-header>
      <div class="users-body">
        <h4>
          Felhasználó hozzáadása
        </h4>
        <div class="user-add-container">
          <div *ngFor="let item of projectUserList;">
            <div class="user-add" *ngIf="!item.isSuperAdminIn(instance.organizationUnit.name) && !userList.includes(item)" (click)="addUser(item)">
              {{item.firstName}} {{item.lastName}}
            </div>
          </div>
        </div>
        <h3>Hozzáadott felhasználók:</h3>
        <div class="user-container" *ngFor="let item of userList;">
          <div>{{item.firstName}} {{item.lastName}}</div>
          <app-button
            *ngIf="projectService.canManageUsers(instance, user, projectPermission)"
            (click)="openPermissionsModal(item)"
            [icon]="'miscellaneous_services'"
            [customColor]="'yellow'"
          ></app-button>
          <app-button
            *ngIf="projectService.canManageUsers(instance, user, projectPermission)"
            [matMenuTriggerFor]="delMenu"
            [icon]="'person_remove'"
            [customColor]="'red'"
          ></app-button>
          <mat-menu class="menu-for-delete" #delMenu="matMenu" xPosition="before">
            <div class="ticket-delete-title">Biztosan törli?</div>
            <div
              class="ticket-delete-option"
              (click)="removeUser(item)"
            >Igen</div>
            <div
              class="ticket-delete-option"
            >nem</div>
          </mat-menu>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="projectPermission.updateLayers || user.isSuperAdminIn(instance.organizationUnit.name)" class="edit-container">
      <mat-expansion-panel-header (click)="$event.stopPropagation()" [collapsedHeight]="'30px'"
        [expandedHeight]="'30px'">
        Rétegmenedzsment
      </mat-expansion-panel-header>
      <app-project-layer-connector [instance]="instance"></app-project-layer-connector>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="projectPermission.updateSchema || user.isSuperAdminIn(instance.organizationUnit.name)" class="edit-container">
      <mat-expansion-panel-header (click)="$event.stopPropagation()" [collapsedHeight]="'30px'"
        [expandedHeight]="'30px'">
        Attribútumok
      </mat-expansion-panel-header>
      <app-list-ticket-attribute [project]="instance"></app-list-ticket-attribute>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="projectPermission.updateSchema || user.isSuperAdminIn(instance.organizationUnit.name)" class="edit-container">
      <mat-expansion-panel-header (click)="$event.stopPropagation()" [collapsedHeight]="'30px'"
        [expandedHeight]="'30px'">
        Kategóriák
      </mat-expansion-panel-header>
      <app-list-ticket-category [project]="instance"></app-list-ticket-category>
    </mat-expansion-panel>
  </mat-accordion>
</div>